"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const StylesCopy = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M6 0H1v2h2.586L.293 5.293l1.414 1.414L5 3.414V6h2V0H6Zm13.225 12.553-2.424-2.425 4.546-3.939.353-.354A2.5 2.5 0 0 0 18.165 2.3l-.354.353-3.94 4.546-2.424-2.424a1 1 0 0 0-1.414 0L8.619 6.189a1 1 0 0 0 0 1.414l7.778 7.778a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414Zm-4.242 2.828L8.619 9.017l-6.465 2.939a1 1 0 0 0-.293 1.617l2.174 2.174 3.874-2.087a.75.75 0 0 1 .711 1.321l-3.478 1.873 5.285 5.285a1 1 0 0 0 1.617-.293l2.939-6.465Z"
      }
    )
  );
};
export default StylesCopy;
